export default "__VITE_ASSET__8479b7dd__"